// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__XFEv3","content":"footer_content__yyFw+","head":"footer_head__8C2Y7","bottom":"footer_bottom__t+puz"};